export const REJECT_ANSWERS = 'DOCUMENT-REJECTION-REASONS';
